import React from 'react';
import SectionCard from './SectionCard';
import { skillsData } from '../data/mock';
import { useLanguage } from '../context/LanguageContext';

const SkillsSection = ({ isDoorOpen }) => {
  const { t, language } = useLanguage();

  const languageLevels = {
    fr: {
      "Français": "Lu, parlé et écrit",
      "Anglais": "Lu, parlé et écrit", 
      "Moore": "Langue maternelle",
      "Dioula": "Seconde langue"
    },
    en: {
      "Français": "Read, spoken and written",
      "Anglais": "Read, spoken and written",
      "Moore": "Native language",
      "Dioula": "Second language"
    }
  };

  return (
    <SectionCard
      id="competences"
      icon="🧠"
      title={t.skills.title}
      subtitle={t.skills.subtitle}
      isDoorOpen={isDoorOpen}
    >
      <div className="grid-2">
        <div>
          <h3>{t.skills.mentalHealth}</h3>
          <ul>
            {t.skills.mentalHealthSkills.map((skill, index) => (
              <li key={index}>{skill}</li>
            ))}
          </ul>

          <h3>{t.skills.protection}</h3>
          <ul>
            {t.skills.protectionSkills.map((skill, index) => (
              <li key={index}>{skill}</li>
            ))}
          </ul>
        </div>
        <div>
          <h3>{t.skills.leadership}</h3>
          <ul>
            {t.skills.leadershipSkills.map((skill, index) => (
              <li key={index}>{skill}</li>
            ))}
          </ul>

          <h3>{t.skills.pedagogy}</h3>
          <ul>
            {t.skills.pedagogySkills.map((skill, index) => (
              <li key={index}>{skill}</li>
            ))}
          </ul>
          <p><strong>{t.skills.tools}:</strong> {skillsData.technical.join(', ')}</p>
          
          <h3 className="mt-4">{t.skills.languages}</h3>
          <div className="languages-grid">
            {skillsData.languages.map((lang, index) => (
              <div key={index} className="language-item">
                <span className="language-name">{lang.name}</span>
                <span className="language-level">{languageLevels[language][lang.name] || lang.level}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </SectionCard>
  );
};

export default SkillsSection;
